import { formatClock, formatDuration } from '../../features/pilotMath/format';
import { pilotSummary } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';
import { InkPreview } from '../../features/ink/InkPreview';
import { StudentNotesPanel } from '../../features/notes/StudentNotesPanel';
import { usePilotLearnerRecord } from '../../features/pilotMath/usePilotLearnerRecord';
import { flattenLearnerAttempts } from '../../features/pilotMath/learnerHistory';
import { env } from '../../lib/env';
import { CloudTeacherStudentMonitorPage } from './CloudTeacherStudentMonitorPage';

function LocalTeacherStudentMonitorPage() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);
  const learner = usePilotLearnerRecord();
  const allAttempts = flattenLearnerAttempts(learner);
  const latest = allAttempts[0];
  const needsAttention = allAttempts.slice(0, 20).filter((attempt) => !attempt.firstAttemptCorrect).length;

  return (
    <div className="stack">
      <div><h1>Monitor Murid</h1><p className="muted">Pilot read-only tutor view. Data berubah saat siswa mengerjakan di browser yang sama atau tab lain.</p></div>
      <section className="card student-monitor-card">
        <div className="student-monitor-card__header">
          <div><div className="eyebrow">Demo siswa</div><h2>{state.student.displayName}</h2><p className="muted">Matematika · Daily Pilot</p></div>
          <span className={`status-dot status-dot--${state.status}`}>{state.status === 'completed' ? 'Selesai' : state.status === 'in_progress' ? 'Sedang belajar' : 'Belum mulai'}</span>
        </div>
        <div className="grid grid--3">
          <div className="metric"><span>Selesai</span><strong>{summary.completed}/{summary.totalQuestions}</strong></div>
          <div className="metric"><span>First-attempt</span><strong>{summary.firstAttemptAccuracy}%</strong></div>
          <div className="metric"><span>Waktu aktif</span><strong>{formatDuration(summary.totalActiveMs)}</strong></div>
        </div>
        {latest && <p className="muted">Aktivitas terakhir {formatClock(latest.completedAt)} · {latest.skillLabel}</p>}
      </section>

      <section className="card">
        <h2>Perlu perhatian</h2>
        {needsAttention === 0 ? <p>Belum ada pola error pada pengerjaan hari ini.</p> : <p><strong>{needsAttention}</strong> soal memerlukan koreksi pada first attempt. Tutor dapat meninjau skill dan riwayat di bawah.</p>}
      </section>

      <section className="card">
        <h2>Skill mastery</h2>
        <div className="skill-list">
          {Object.values(learner.progress).filter((skill) => skill.evidenceCount > 0).map((skill) => (
            <div className="skill-row" key={skill.skillCode}>
              <div><strong>{skill.label}</strong><div className="muted skill-code">{skill.skillCode}</div></div>
              <div className="skill-mastery"><strong>{skill.masteryPercent}%</strong><span className="muted">evidence {skill.evidenceCount}</span></div>
            </div>
          ))}
          {state.attempts.length === 0 && <p className="muted">Belum ada evidence baru hari ini.</p>}
        </div>
      </section>

      <section className="card">
        <h2>History terbaru</h2>
        <div className="history-list">
          {allAttempts.slice(0, 8).map((attempt) => (
            <article className="history-item" key={attempt.id}>
              <div><strong>{attempt.prompt}</strong><div className="muted">{attempt.skillLabel}</div></div>
              <div className="history-item__detail">
                <span>{attempt.firstAttemptCorrect ? '✓ benar pertama' : `koreksi ${attempt.firstResponse} → ${attempt.finalResponse}`}</span>
                <span>{formatDuration(attempt.duration.activeDurationMs)}</span>
                <span>{attempt.previousMastery}% → {attempt.newMastery}%</span>{attempt.misconceptionSignals?.map((signal) => <span key={signal.code}>⚠ {signal.code}</span>)}
              </div>
              {attempt.ink && attempt.ink.strokes.length > 0 && (
                <details className="ink-history"><summary>Lihat tulisan ({attempt.ink.strokes.length} stroke)</summary><InkPreview document={attempt.ink} /></details>
              )}
            </article>
          ))}
          {allAttempts.length === 0 && <p className="muted">History akan muncul setelah siswa mulai mengerjakan.</p>}
        </div>
      </section>
      <StudentNotesPanel
        studentId={state.student.id}
        viewerRole="teacher"
        authorName="Tutor Matematika"
        allowCreate
        defaultNoteType="learning"
        subjectCode="MTH"
        title="Catatan tutor / guru"
      />

    </div>
  );
}


export function TeacherStudentMonitorPage() {
  if (env.supabaseUrl && env.supabasePublishableKey) return <CloudTeacherStudentMonitorPage />;
  return <LocalTeacherStudentMonitorPage />;
}
